import React, { Component } from "react";
import { Grid, Box, CardContent, CardMedia, IconButton } from "@mui/material";
import CtTxt from "./CustomTool/CtTxt";
import CtDtp from "./CustomTool/CtDtp";
import CtTxtAmt from "./CustomTool/CtTxtAmt";
import CtTxtNum from "./CustomTool/CtTxtNum";
import CtCmb from "./CustomTool/CtCmb";
import TextAreaAutoSize from "./CustomTool/TextAreaAutoSize";
import CtBtn from "./CustomTool/CtBtn";
import {
  Edit,
  Delete,
  ThirtyFpsSharp,
  AddBox,
  StarSharp,
} from "@mui/icons-material";
import CtMultiLineText from "./CustomTool/CtMultiLineText";
import { withRouter } from "../HOC/withRouter";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";
import { connect } from "react-redux";
import Progress from "./CustomTool/Progress";
import {
  mapStatetoProps,
  mapSetActiveMenuToProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
} from "../mapRedux/mapReduxProps";
import {
  fetchCustomerMaster,
  fetchDriverDetail,
  fetchLoadUnload,
  fetchPlaceDetail,
  fetchSales,
  fetchTripDetail,
  fetchTruckDetail,
  fetchWayBridgeDetail,
} from "./API";
import {
  get_YMD_from_SYS,
  get_30DaysBack_FromCurrentDate,
  isValidItem,
  getlocalstoragedate,
  setlocalstoragedate,
  applyTrimOnObjectValues,
  csvFileName,
  validatedate_min_max,
  setKeyboardShortcuts,
} from "../SystemUtility/SystemUtility";
import TableList from "./CustomTool/TableList";
import VehicleUnload from "./VehicleUnload";
import CtCmbEditable from "./CustomTool/CtCmbEditable";
import ResetDate from "../images/resetdate.png";
import MaterialTable from "./CustomTool/MaterialTable";
import CustomerMaster from "./CustomerMaster";
import LedgerMaster from "./LedgerMaster";
import TripItemEntry from "./TripItemEntry";
import TruckMaster from "./TruckMaster";
import DriverMaster from "./DriverMaster";
import PlaceMaster from "./PlaceMaster";
import WayBridgeMaster from "./WayBridgeMaster";
import PaymentModeTable from "./PaymentModeTable";
import moment from "moment";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import PaymentModeIcon from "../images/Payment Mode icon.jpg";

class TripEntry extends Component {
  state = {
    rowsPaymentMode: [],
    PaymentData: [],
    DefaultEntrySettingList: [],
    Truck: [],
    Driver: [],
    WayBridge: [],
    Place: [],
    Customer: [],
    TripRate: [],
    LedgerList: [],
    WayBridgeCharge: [],
    Type: ["Paid", "Remain"],
    ispaid: false,
    formData: {
      dtpDate: get_YMD_from_SYS(new Date()),
      txtTripCode: "",
      TripDate: "",
      cmbTruckNo: "",
      cmbDriver: "",
      cmbPartyCustomer: "",
      txtItemTotal: "",
      txtTripRate: "",
      cmbWayBridge: "",
      txtWayBridgeCharge: "",
      txtTripTotalAmount: "",
      cmbDeparture: "",
      cmbDestination: "",
      txtNetWt: "",
      txtTransportRate: "",
      txtTransportAmount: "",
      cmbType: "Remain",
      txtAmount: 0,
      txtDiseal: "",
      txtDistance: "",
      txtnowheels: "",
      vac_customerledgername: "",
      vac_customergroupname: "",
      bint_customerladgercode: "",
      vac_salesledgername: "",
      vac_salesgroupname: "",
      bint_salesladgercode: "",
      vac_purchaseledgername: "",
      vac_purchasegroupname: "",
      bint_purchasesladgercode: "",
      vac_driverledgername: "",
      vac_drivergroupname: "",
      bint_driverladgercode: "",
      vac_waybridgeledgername: "",
      vac_waybridgegroupname: "",
      bint_waybridgledgercode: "",
      bint_ledgercodewaybridge: "",
    },
    asOpenedTransactionType: false,
    columns: [
      {
        accessorKey: "bint_tripcode",
        header: " Sr. No.",
      },
      {
        accessorKey: "vac_candidatecode",
        header: "Item Name",
        size: 200,
      },
      {
        accessorKey: "vac_firstname",
        header: " Wt",
        size: 200,
      },

      {
        accessorKey: "vac_cast",
        header: "Rate",
      },
      {
        accessorKey: "ObtainedMarks",
        header: " Amount",
        size: 200,
      },
      {
        accessorKey: "ObtainedMarks",
        header: "Remark",
        size: 200,
      },
    ],
    columnsPaymentMode: [
      // { id: "Action", label: "Search", name: "Search" },
      // { id: 'bint_tripcode', label: 'SR NO' },
      { id: "vac_ledgername", label: "Payment Mode Ledger" },
      {
        id: "dec_amount",
        label: "Amount",
        type: "CtTxtAmt",
        CtrlProps: { value: "", width: 100, maxLength: 20 },
      },
      {
        id: "vac_chequeno",
        label: "Cheque No",
        type: "CtTxtNum",
        CtrlProps: { value: "", width: 100, maxLength: 20 },
      },
      {
        id: "vac_referenceno",
        label: "Reference No",
        type: "CtTxtNum",
        CtrlProps: { value: "", width: 100, maxLength: 20 },
      },
      {
        id: "dat_transactiondate",
        label: "Transaction Date",
        type: "CtDtp",
        CtrlProps: { value: "", maxLength: 20 },
      },
      {
        id: "vac_remark",
        label: "Remark",
        type: "CtMultiLineText",
        CtrlProps: { value: "", width: 120, maxLength: 100 },
      },
      { id: "vac_groupname", label: "Group Name", hide: true },
    ],
    rowsPaymentMode: [],
    rowsCountPaymentMode: 0,
    rowsPerPagePaymentMode: 5,
    PaymentmodeListCols: [
      "bint_acid",
      "bint_ledgercode",
      "bint_ledgeridsrno",
      "dec_opbalance",
      "vac_backgroundprocess",
      "vac_company",
      "vac_firmname",
      "vac_groupheader",
      "vac_groupname",
      "vac_gstno",
      "vac_ledgername",
    ],

    rowsCount: 0,
    rowsPerPage: 50,
    counter: 0,
    isEditMode: false, // Tracks edit mode
    isInitialLoad: true, // Tracks first load
    hasOpenedTransactionType: false,
    dataLoadStatus: true,
    ARD: null,
    removeKeyboardShortCuts: null,
    isSaving: false,
  };

  //#region Component
  componentDidMount() {
    document.title = "RiTe Account : Trip Entry";
    this.props.setActiveMenu("TripEntry");
    this.ShortCut();
    this.props.verifyUserID(
      this.onFormLoad,
      this.props.navInfo.subMenuMaster,
      this.props.setSubMenu_Master_Entry,
      this.props.setUserPrivileges
    );
  }

  //#endregion Component

  //#region Handle
  // setnowheelsDetail = () => {
  //   if (this.state.Truck.length > 0) {
  //     this.state.Truck.map((row) => {
  //       if (row.vac_truckno == this.state.formData.cmbTruckNo) {
  //         this.setState(
  //           {
  //             formData: {
  //               ...this.state.formData,
  //               txtnowheels: row.int_noofwheels,
  //             },
  //           },
  //           () => {
  //             return;
  //           }
  //         );
  //         console.log("txtnowheels", this.state.formData.txtnowheels);
  //       }
  //     });
  //   }
  // };

  setTripRateDetail = () => {
    let selectedTruck = this.state.Truck.find(
      (truck) => truck.vac_truckno === this.state.formData.cmbTruckNo
    );
    if (!selectedTruck) {
      return;
    }
    if (this.state.TripRate.length > 0) {
      let matchingRate = this.state.TripRate.find((row) => {
        let isMatch =
          selectedTruck.int_noofwheels === row.int_noofwheels &&
          row.vac_destination === this.state.formData.cmbDestination;

        return isMatch;
      });

      if (matchingRate) {
        this.setState(
          {
            formData: {
              ...this.state.formData,
              txtTripRate: matchingRate.dec_triprate,
            },
          },
          () => {
            this.calculateTripTotalAmount();
          }
        );
      } else {
        this.setState(
          {
            formData: {
              ...this.state.formData,
              txtTripRate: "",
            },
          },
          () => {
            this.calculateTripTotalAmount();
          }
        );
      }
    }
  };

  setLedgerDetail = () => {
    const { LedgerList, formData } = this.state;
    if (LedgerList.length === 0) return;

    const updates = {
      vac_salesledgername: "",
      vac_salesgroupname: "",
      bint_salesladgercode: null,
      vac_purchaseledgername: "",
      vac_purchasegroupname: "",
      bint_purchasesladgercode: null,
      vac_customerledgername: "",
      vac_customergroupname: "",
      bint_customerladgercode: null,
      vac_driverledgername: "",
      vac_drivergroupname: "",
      bint_driverladgercode: null,
      vac_waybridgeledgername: "",
      vac_waybridgegroupname: "",
      bint_waybridgledgercode: null,
      bint_ledgercodewaybridge: null,
    };

    LedgerList.forEach((row) => {
      switch (row.vac_ledgername) {
        case "Sales":
          updates.vac_salesledgername = row.vac_ledgername;
          updates.vac_salesgroupname = row.vac_groupname;
          updates.bint_salesladgercode = row.bint_ledgercode;
          break;
        case "Purchase":
          updates.vac_purchaseledgername = row.vac_ledgername;
          updates.vac_purchasegroupname = row.vac_groupname;
          updates.bint_purchasesladgercode = row.bint_ledgercode;
          break;
        case formData.cmbPartyCustomer:
          updates.vac_customerledgername = row.vac_ledgername;
          updates.vac_customergroupname = row.vac_groupname;
          updates.bint_customerladgercode = row.bint_ledgercode;
          break;
        case formData.cmbDriver:
          updates.vac_driverledgername = row.vac_ledgername;
          updates.vac_drivergroupname = row.vac_groupname;
          updates.bint_driverladgercode = row.bint_ledgercode;
          break;
        case formData.cmbWayBridge:
          // Only set these values if cmbType is not "Paid"
          if (this.state.formData.cmbType !== "Paid") {
            updates.vac_waybridgeledgername = row.vac_ledgername;
            updates.vac_waybridgegroupname = row.vac_groupname;
            updates.bint_waybridgledgercode = row.bint_ledgercode;
            updates.bint_ledgercodewaybridge = row.bint_ledgercode;
          }
          break;
      }
    });

    // If cmbType is "Paid", set the waybridge values from rowsPaymentMode
    if (
      this.state.formData.cmbType === "Paid" &&
      this.state.rowsPaymentMode &&
      this.state.rowsPaymentMode.length > 0
    ) {
      // Find the first row where dec_amount > 0
      const paymentRow = this.state.rowsPaymentMode.find(
        (row) => row.dec_amount > 0
      );
      console.log("paymentRow", paymentRow);

      if (paymentRow) {
        updates.vac_waybridgeledgername = paymentRow.vac_ledgername || "";
        updates.vac_waybridgegroupname = paymentRow.vac_groupname || "";
        updates.bint_waybridgledgercode = paymentRow.vac_ledgercode || null;
        LedgerList.forEach((row) => {
          switch (row.vac_ledgername) {
            case formData.cmbWayBridge:
              updates.bint_ledgercodewaybridge = row.bint_ledgercode;
              break;
          }
        });
      } else {
        // Handle case where no row has dec_amount > 0
        updates.vac_waybridgeledgername = "";
        updates.vac_waybridgegroupname = "";
        updates.bint_waybridgledgercode = null;
      }
    }
    this.setState(
      {
        formData: {
          ...formData,
          ...updates,
        },
      },
      () => {}
    );
  };
  setWayBridgeChargeDetail = () => {
    const selectedTruck = this.state.Truck.find(
      (truck) => truck.vac_truckno === this.state.formData.cmbTruckNo
    );

    if (!selectedTruck) {
      return;
    }
    const matchingCharge = this.state.WayBridgeCharge.find(
      (row) => row.int_noofwheels === selectedTruck.int_noofwheels
    );
    if (this.state.formData.txtWayBridgeCharge === "" || 0) {
      if (this.state.formData.cmbWayBridge) {
        if (matchingCharge) {
          this.setState(
            (prevState) => {
              const targetLedgerNames = prevState.DefaultEntrySettingList.map(
                (row) => row.vac_ledgername
              ).filter(Boolean);

              const updatedRowsPaymentMode = prevState.rowsPaymentMode.map(
                (row) => {
                  if (targetLedgerNames.includes(row.vac_ledgername)) {
                    return {
                      ...row,
                      dec_amount: parseFloat(matchingCharge.dec_rate),
                      chk_paymentmode: true,
                    };
                  }
                  return row;
                }
              );

              return {
                formData: {
                  ...prevState.formData,
                  txtWayBridgeCharge: matchingCharge.dec_rate,
                },
                rowsPaymentMode: updatedRowsPaymentMode,
              };
            },
            () => {
              this.calculateTripTotalAmount();
              this.setRemain();
            }
          );
        } else {
          this.setState(
            {
              formData: {
                ...this.state.formData,
                txtWayBridgeCharge: "",
              },
            },
            () => {
              this.calculateTripTotalAmount();
              this.setRemain();
            }
          );
        }
      }
    }
    if (
      this.state.formData.cmbWayBridge === "" &&
      this.state.formData.txtWayBridgeCharge
    ) {
      this.setState(
        {
          formData: {
            ...this.state.formData,
            txtWayBridgeCharge: "",
          },
        },
        () => {
          this.calculateTripTotalAmount();
          this.setRemain();
        }
      );
    }
  };
  calculateTransportAmount = () => {
    let { txtNetWt, txtTransportRate } = this.state.formData;

    // Ensure values are treated as numbers
    let netWt = parseFloat(txtNetWt) || 0;
    let transportRate = parseFloat(txtTransportRate) || 0;

    let transportAmount = (netWt * transportRate).toFixed(2);

    this.setState(
      (prevState) => ({
        formData: {
          ...prevState.formData,
          txtTransportAmount: transportAmount,
        },
      }),
      () => {
        this.calculateTripTotalAmount();
      }
    );
  };

  calculateTripTotalAmount = () => {
    let { txtTransportAmount, txtTripRate, txtWayBridgeCharge } =
      this.state.formData;

    let txtTripTotalAmount = (
      txtTransportAmount -
      txtTripRate -
      txtWayBridgeCharge
    ).toFixed(2);

    this.setState(
      (prevState) => ({
        formData: {
          ...prevState.formData,
          txtTripTotalAmount,
        },
      }),
      () => {
        this.setLedgerDetail();
      }
    );
  };
  setRemain = () => {
    let { txtWayBridgeCharge } = this.state.formData;
    if (Number(txtWayBridgeCharge) === 0 || txtWayBridgeCharge === "") {
      this.setState({
        formData: {
          ...this.state.formData,
          cmbType: "Remain",
        },
      });
    }
  };
  handleOnChange = (e) => {
    this.setState(
      {
        formData: { ...this.state.formData, [e.target.name]: e.target.value },
      },
      () => {
        if (e.target.name === "cmbType") {
          // Only open if:
          // 1. User manually selects "Paid" (not initial load)
          // 2. Not already opened
          if (
            this.state.formData.cmbType === "Paid" &&
            !this.state.isInitialLoad &&
            !this.state.hasOpenedTransactionType
          ) {
            this.handleSelectTransactionType();
          }
          // Reset initial load after first change
          if (this.state.isInitialLoad) {
            this.setState({ isInitialLoad: false });
          }
        } else if (this.state.formData.cmbType === "Remain") {
          this.setState({ hasOpenedTransactionType: false });
        }
        if (
          e.target.name === "txtNetWt" ||
          e.target.name === "txtTransportRate"
        ) {
          this.calculateTransportAmount();
        }

        if (
          e.target.name === "txtTransportAmount" ||
          e.target.name === "txtTripRate" ||
          e.target.name === "txtWayBridgeCharge"
        ) {
          this.calculateTripTotalAmount();
        }

        // if (e.target.name === "cmbTruckNo") {
        //   this.setnowheelsDetail();
        // }
        if (
          e.target.name === "cmbTruckNo" ||
          e.target.name === "cmbWayBridge"
        ) {
          this.setWayBridgeChargeDetail();
        }
        if (
          e.target.name === "cmbTruckNo" ||
          e.target.name === "cmbDestination"
        ) {
          this.setTripRateDetail();
        }
        if (
          e.target.name === "cmbDriver" ||
          // e.target.name === "cmbWayBridge" ||
          e.target.name === "cmbPartyCustomer" ||
          e.target.name === "cmbType"
        ) {
          this.setLedgerDetail();
        }
        if (e.target.name === "txtWayBridgeCharge") {
          this.setRemain();
          this.setState(
            (prevState) => {
              const targetLedgerNames = prevState.DefaultEntrySettingList.map(
                (row) => row.vac_ledgername
              ).filter(Boolean);

              const updatedRowsPaymentMode = prevState.rowsPaymentMode.map(
                (row) => {
                  if (targetLedgerNames.includes(row.vac_ledgername)) {
                    return {
                      ...row,
                      dec_amount: this.state.formData.txtWayBridgeCharge,
                      chk_paymentmode: true,
                    };
                  }
                  return row;
                }
              );

              return {
                rowsPaymentMode: updatedRowsPaymentMode,
              };
            },
            () => {
              console.log("Updated payment modes:", this.state.rowsPaymentMode);
            }
          );
        }
      }
    );
  };

  handleSelectTransactionType = () => {
    if (!(this.state.isEditMode && this.state.isInitialLoad)) {
      // Only open if NOT in edit mode
      this.openTransactionType();
      this.getPaymentModeDataStatus();
    }

    // if (type === " Advance") {
    //   this.getPaymentModeDataStatus();
    //   this.openTransactionType();
    // }
    // Update transaction type
  };

  DeleteData = () => {
    if (this.state.formData.txtTripCode > 0) {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={
              "Do you want Delete to  " +
              "Trip No: " +
              this.state.formData.txtTripCode +
              " " +
              "Truck No: " +
              this.state.formData.cmbTruckNo +
              " " +
              " Customer: " +
              this.state.formData.cmbPartyCustomer +
              "?"
            }
            alertMessage=""
            handleOnClickYes={() => {
              return this.DeleteTrip(this.state.formData.txtTripCode);
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );

        this.setState({ ARD });
      });
    } else {
      this.props.toastErrorMsg("Select a record for deletion.");
    }
  };

  DeleteTrip = (txtTripCode) => {
    this.props.notifyProcessing();
    let reqData = {
      Op: "DeleteTrip",
      bint_acid: localStorage.getItem("acid"),
      bint_acyear: localStorage.getItem("ACY"),
      bint_tripcode: txtTripCode,
      // bol_list: true,
    };
    fetchTripDetail(reqData)
      .then((res) => {
        this.props.updateProcessing(res.data.msgType, res.data.message);
        if (res.data.msgType === "success") {
          this.setState(
            {
              ARD: null,
            },
            () => {
              this.clearInfo();
            }
          );
        }
      })
      .catch((error) => {
        this.props.updateProcessing(
          "error",
          "Unknown error occurred in delete Check list. " + error
        );
      });
    return false;
  };
  //   console.log("row", row);
  //   // console.log('row.original["bint_tripcode"]', row.original["bint_tripcode"]);
  //   let txtTripCode= row.getValue("bint_tripcode");
  //   TripDate=row.getValue("");
  //   cmbTruckNo=row.getValue("");
  //   cmbDriver=row.getValue("");
  //   cmbPartyCustomer=row.getValue("");
  //   txtItemTotal=row.getValue("");
  //   txtTripRate=row.getValue("");
  //   cmbWayBridge=row.getValue("");
  //   txtWayBridgeCharge=row.getValue("");
  //   txtTripTotalAmount=row.getValue("");
  //   cmbDeparture=row.getValue("");
  //   cmbDestination=row.getValue("");
  //   txtNetWt=row.getValue("");
  //   txtTransportRate=row.getValue("");
  //   txtTransportAmount=row.getValue("");
  //   cmbType=row.getValue("");
  //   txtAmount=row.getValue("");
  //   txtDiseal=row.getValue("");
  //   txtDistance=row.getValue("");
  //   // let rows2 = row.original.CheckToDoList;
  //   // console.log("rows2", rows2);
  //   this.setState({
  //     formData: {
  //       ...this.state.formData,
  //       txtTripCode,
  //       txtPlaceName,
  //     },
  //   });
  //   window.scrollTo(0, 0);
  //   document.getElementById("txtPlaceName").focus();
  // };
  handleOnNewEntryClick = () => {
    let ARD = null;
    this.setState({ ARD }, () => {
      ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          // New : Sales Item Entry'
          alertMessage={<TripItemEntry />}
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
        />
      );
      this.setState({ ARD });
    });
  };

  handleChangeRowsPerPage = (rowsPerPage) => {
    this.setState({ rowsPerPage });
  };

  handleOnRowDataChange = (rows, handledRowIndex, colID) => {
    this.setState({ rows, rowsCount: rows.length }, () => {});
  };
  componentWillUnmount() {
    this.removeKeyboardShortCuts();
  }
  removeKeyboardShortCuts = () => {
    if (this.state.removeKeyboardShortCuts) {
      this.state.removeKeyboardShortCuts();
      this.setState({ removeKeyboardShortCuts: null });
    }
  };
  ShortCut = () => {
    this.setState({
      removeKeyboardShortCuts: setKeyboardShortcuts({
        handleOnclickSave: this.SaveTrip,
        handleOnclickNew: this.clearInfo,
        handleOnclickDelete: this.DeleteData,
        handleOnclickPluse: this.handleDynamicShortcut,
        handleOnclickList: () => {
          this.props.navigateTo("TripList");
        },
      }),
    });
  };
  handleDynamicShortcut = () => {
    const activeElement = document.activeElement;

    if (!activeElement) return;

    const elementId = activeElement.id;

    switch (elementId) {
      case "cmbTruckNo":
        this.onAddClickMasterTruck();
        break;
      case "cmbPartyCustomer":
        this.onAddClickCustomerMaster();
        break;
      case "cmbDriver":
        this.onAddClickDriver();
        break;
      case "cmbDeparture":
      case "cmbDestination":
        this.onClickPlaceMaster();
        break;
      case "cmbWayBridge":
        this.onAddClickWayBridgeMaster();
        break;
      default:
        console.log("No handler found for element:", elementId);
    }
  };

  //#endregion handle
  onAddClickMasterTruck = () => {
    this.setState({ ARD: null }, () => {
      this.removeKeyboardShortCuts();
      let ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          alertMessage=<TruckMaster showHeading={true} />
          maxWidthClass={"xl"}
          defaultOpenDialog={true}
          handleOnClickNo={() => {
            this.getTruckList();
            this.ShortCut();
          }}
        />
      );
      this.setState({ ARD });
    });
  };

  onAddClickCustomerMaster = () => {
    this.setState({ ARD: null }, () => {
      this.removeKeyboardShortCuts();
      let ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          maxWidthClass={"xl"}
          alertMessage=<CustomerMaster showHeading={true} />
          defaultOpenDialog={true}
          handleOnClickNo={() => {
            this.getCustomerList();
            this.ShortCut();
          }}
        />
      );
      this.setState({ ARD });
    });
  };

  onAddClickWayBridgeMaster = () => {
    this.setState({ ARD: null }, () => {
      this.removeKeyboardShortCuts();
      let ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          maxWidthClass={"xl"}
          alertMessage=<WayBridgeMaster showHeading={true} />
          defaultOpenDialog={true}
          handleOnClickNo={() => {
            this.getWayBridgeList();
            this.ShortCut();
          }}
        />
      );
      this.setState({ ARD });
    });
  };

  onAddClickDriver = () => {
    this.setState({ ARD: null }, () => {
      this.removeKeyboardShortCuts();
      let ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          maxWidthClass={"xl"}
          alertMessage=<DriverMaster showHeading={true} />
          defaultOpenDialog={true}
          handleOnClickNo={() => {
            this.getDriver();
            this.ShortCut();
          }}
        />
      );
      this.setState({ ARD });
    });
  };

  onClickPlaceMaster = () => {
    this.setState({ ARD: null }, () => {
      this.removeKeyboardShortCuts();
      let ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          maxWidthClass={"xl"}
          alertMessage=<PlaceMaster showHeading={true} />
          defaultOpenDialog={true}
          handleOnClickNo={() => {
            this.getPlace();
            this.ShortCut();
          }}
        />
      );
      this.setState({ ARD });
    });
  };

  trimFormData = (nextFunctionCall) => {
    let formData = applyTrimOnObjectValues({
      formData: this.state.formData,
      // excludeKeysArray: [""],
    });
    this.setState({ formData }, () => {
      if (nextFunctionCall) {
        nextFunctionCall();
      }
    });
  };

  getPlace = () => {
    this.props.notifyProcessing();
    let reqData = {
      Op: "LoadPlace",
      bint_acid: localStorage.getItem("acid"),
    };
    fetchPlaceDetail(reqData)
      .then((res) => {
        this.props.updateProcessing("success", "Place List Loaded");
        let Place = res.data.PlaceList;
        this.setState(
          {
            Place,
          },
          () => {
            // console.log("this.state", this.state);
          }
        );
      })
      .catch((error) => {
        console.log("Unknown error occurred in getPlace.", error);
      });
  };

  getDriver = () => {
    this.props.notifyProcessing();
    let reqData = {
      Op: "LoadDriver",
      bint_acid: localStorage.getItem("acid"),
    };
    fetchDriverDetail(reqData)
      .then((res) => {
        this.props.updateProcessing("success", "Driver List Loaded");
        let Driver = res.data.DriverList;
        this.setState(
          {
            Driver,
          },
          () => {
            // console.log("this.state", this.state);
          }
        );
      })
      .catch((error) => {
        console.log("Unknown error occurred in getDriver.", error);
      });
  };

  getWayBridgeList = () => {
    this.props.notifyProcessing();
    let reqData = {
      Op: "LoadWayBridge",
      bint_acid: localStorage.getItem("acid"),
    };
    fetchWayBridgeDetail(reqData)
      .then((res) => {
        this.props.updateProcessing("success", "WayBridge List Loaded");
        let WayBridge = res.data.WayBridgeList;
        this.setState(
          {
            WayBridge,
          },
          () => {
            // console.log("this.state", this.state);
          }
        );
      })
      .catch((error) => {
        console.log("Unknown error occurred in getWayBridgeList.", error);
      });
  };

  getTruckList = () => {
    this.props.notifyProcessing();
    let reqData = {
      Op: "LoadTruck",
      bint_acid: localStorage.getItem("acid"),
    };
    fetchTruckDetail(reqData)
      .then((res) => {
        this.props.updateProcessing("success", "Truck List Loaded");
        let Truck = res.data.TruckList;
        this.setState(
          {
            Truck,
          },
          () => {
            // console.log("this.state", this.state);
          }
        );
      })
      .catch((error) => {
        console.log("Unknown error occurred in getTruckList.", error);
      });
  };

  getCustomerList = () => {
    this.props.notifyProcessing();
    let reqData = {
      Op: "LoadCustomerDetails",
      bint_acid: localStorage.getItem("acid"),
    };
    fetchCustomerMaster(reqData)
      .then((res) => {
        this.props.updateProcessing("success", "Customer List Loaded");
        let Customer = res.data.CustomerList;
        this.setState(
          {
            Customer,
          },
          () => {
            // console.log("this.state", this.state);
          }
        );
      })
      .catch((error) => {
        console.log("Unknown error occurred in getCustomerList.", error);
      });
  };

  getInfo = () => {};

  onFormLoad = () => {
    let dataLoadStatus = false;

    this.setState(
      { dataLoadStatus, autoResetFormData: false, isInitialLoad: true },
      () => {
        let bint_acyear = 0,
          bint_acid = "",
          bint_tripcode = 0;
        if (this.props.location.state && this.props.location.state != null) {
          this.setState({ isEditMode: true });
          bint_acid = this.props.location.state.bint_acid;
          bint_tripcode = this.props.location.state.bint_tripcode;
          bint_acyear = this.props.location.state.bint_acyear;
          let reqData = {
            Op: "TripData",
            bint_acyear,
            bint_acid,
            bint_tripcode,
            vac_userid: localStorage.getItem("logInID"),
            bint_ci: localStorage.getItem("CI"),
          };
          fetchTripDetail(reqData)
            .then((res) => {
              this.props.updateProcessing(res.data.msgType, res.data.message);
              let TripRate = [],
                WayBridgeCharge = [],
                Customer = [],
                Truck = [],
                Driver = [],
                WayBridge = [],
                Place = [],
                DefaultEntrySettingList = res.data.DefaultEntrySettingList,
                rowsPaymentMode = [],
                LedgerList = [],
                PaymentData = [],
                ispaid = false,
                rowsCountPaymentMode = rowsPaymentMode.length;

              if (res.data.CustomerList && res.data.CustomerList.length > 0) {
                Customer = res.data.CustomerList;
                if (
                  res.data.LedgerNameList &&
                  res.data.LedgerNameList.length > 0
                ) {
                  rowsPaymentMode = res.data.LedgerNameList;
                  rowsCountPaymentMode = rowsPaymentMode.length;
                }

                if (res.data.PaymentData && res.data.PaymentData.length > 0) {
                  PaymentData = res.data.PaymentData;
                  ispaid = false;
                } else {
                  ispaid = true;
                }
                if (res.data.LedgerList && res.data.LedgerList.length > 0) {
                  LedgerList = res.data.LedgerList;
                }
                if (res.data.TruckList && res.data.TruckList.length > 0) {
                  Truck = res.data.TruckList;
                }
                if (res.data.DriverList && res.data.DriverList.length > 0) {
                  Driver = res.data.DriverList;
                }
                if (
                  res.data.WayBridgeList &&
                  res.data.WayBridgeList.length > 0
                ) {
                  WayBridge = res.data.WayBridgeList;
                }
                if (res.data.PlaceList && res.data.PlaceList.length > 0) {
                  Place = res.data.PlaceList;
                }
                if (
                  res.data.DriverTripRateList &&
                  res.data.DriverTripRateList.length > 0
                ) {
                  TripRate = res.data.DriverTripRateList;
                }
                if (res.data.PaymentData && res.data.PaymentData.length > 0) {
                  res.data.PaymentData.map((odd) => {
                    let isFound = 0;
                    rowsPaymentMode.map((rod) => {
                      if (rod.vac_ledgername === odd.vac_ledgername) {
                        // rod.vac_value = odd.vac_value;
                        rod.dec_amount = odd.dec_amount;
                        rod.vac_chequeno = odd.vac_chequeno;
                        rod.vac_referenceno = odd.vac_referenceno;
                        rod.dat_transactiondate = odd.dat_transactiondate;
                        rod.vac_remark = odd.vac_remark;
                        rod.vac_groupname = odd.vac_groupname;
                        isFound++;
                      }
                    });
                    if (isFound === 0) {
                      rowsPaymentMode.push({
                        vac_ledgername: odd.vac_ledgername,
                        dec_amount: odd.dec_amount,
                        vac_chequeno: odd.vac_chequeno,
                        vac_referenceno: odd.vac_referenceno,
                        dat_transactiondate: odd.dat_transactiondate,
                        vac_remark: odd.vac_remark,
                        vac_groupname: odd.vac_groupname,
                        // bint_displayorderno: rowsPaymentMode.length + 1,
                      });
                    }
                  });
                  rowsCountPaymentMode = rowsPaymentMode.length;
                }

                if (
                  res.data.WayBridgeChargeList &&
                  res.data.WayBridgeChargeList.length > 0
                ) {
                  WayBridgeCharge = res.data.WayBridgeChargeList;
                }

                console.log("res.data.PaymentData", res.data.PaymentData);

                // this.setState(
                //   Customer,
                //   rowsPaymentMode,
                //   rowsCountPaymentMode,
                //   PaymentData,
                //   Truck,
                //   Driver,
                //   WayBridge,
                //   Place,
                //   {
                //     formData: {
                //       ...this.state.formData,
                //       dtpDate: res.data.TripList[0].dat_tripdate || "",
                //       txtTripCode: res.data.TripList[0].bint_tripcode || "",
                //       TripDate: res.data.TripList[0].dat_tripdate || "",
                //       cmbTruckNo: res.data.TripList[0].vac_truckno || "",
                //       cmbDriver: res.data.TripList[0].vac_driver || "",
                //       cmbPartyCustomer: res.data.TripList[0].vac_customer || "",
                //       txtTripRate: res.data.TripList[0].dec_triprate || "",
                //       cmbWayBridge: res.data.TripList[0].vac_waybridgename || "",
                //       txtWayBridgeCharge:
                //         res.data.TripList[0].dec_waybridgecharge || "",
                //       txtTripTotalAmount:
                //         res.data.TripList[0].dec_triptotalamount || "",
                //       cmbDeparture: res.data.TripList[0].vac_departure || "",
                //       cmbDestination: res.data.TripList[0].vac_destination || "",
                //       txtNetWt: res.data.TripList[0].dec_netwt || "",
                //       txtTransportRate:
                //         res.data.TripList[0].dec_transportrate || "",
                //       txtTransportAmount:
                //         res.data.TripList[0].dec_transportamount || "",
                //       cmbType: res.data.TripList[0].vac_wbc_trantype || "",
                //       txtDiseal: res.data.TripList[0].dec_diseal || "",
                //       txtDistance: res.data.TripList[0].dec_distance || "",
                //     },
                //   }
                // );
                this.setState(
                  {
                    ispaid,
                    Customer,
                    rowsPaymentMode,
                    rowsCountPaymentMode,
                    PaymentData,
                    Truck,
                    Driver,
                    WayBridge,
                    Place,
                    DefaultEntrySettingList,
                    TripRate,
                    LedgerList,
                    WayBridgeCharge,
                    formData: {
                      ...this.state.formData,
                      dtpDate: res.data.TripList[0]?.dat_tripdate || "",
                      txtTripCode: res.data.TripList[0]?.bint_tripcode || "",
                      TripDate: res.data.TripList[0]?.dat_tripdate || "",
                      cmbTruckNo: res.data.TripList[0]?.vac_truckno || "",
                      cmbDriver: res.data.TripList[0]?.vac_driver || "",
                      cmbPartyCustomer:
                        res.data.TripList[0]?.vac_customer || "",
                      txtTripRate: res.data.TripList[0]?.dec_triprate || "",
                      cmbWayBridge:
                        res.data.TripList[0]?.vac_waybridgename || "",
                      txtWayBridgeCharge:
                        res.data.TripList[0]?.dec_waybridgecharge || "",
                      txtTripTotalAmount:
                        res.data.TripList[0]?.dec_triptotalamount || "",
                      cmbDeparture: res.data.TripList[0]?.vac_departure || "",
                      cmbDestination:
                        res.data.TripList[0]?.vac_destination || "",
                      txtNetWt: res.data.TripList[0]?.dec_netwt || "",
                      txtTransportRate:
                        res.data.TripList[0]?.dec_transportrate || "",
                      txtTransportAmount:
                        res.data.TripList[0]?.dec_transportamount || "",
                      cmbType: res.data.TripList[0]?.vac_wbc_trantype || "",
                      txtDiseal: res.data.TripList[0]?.dec_diseal || "",
                      txtDistance: res.data.TripList[0]?.dec_distance || "",

                      // dtpDate: res.data.TripList[0].dtpDate,
                      // txtTripCode: this.props.location.state.bint_tripcode,
                      // TripDate: this.pros.location.state.TripDate,
                      // cmbTruckNo: this.pros.location.state.cmbTruckNo,
                      // cmbDriver: this.pros.location.state.cmbDriver,
                      // cmbPartyCustomer: this.pros.location.state.cmbPartyCustomer,
                      // txtTripRate: this.pros.location.state.txtTripRate,
                      // cmbWayBridge: this.pros.location.state.cmbWayBridge,
                      // txtWayBridgeCharge:
                      //   this.pros.location.state.txtWayBridgeCharge,
                      // txtTripTotalAmount:
                      //   this.pros.location.state.txtTripTotalAmount,
                      // cmbDeparture: this.pros.location.state.cmbDeparture,
                      // cmbDestination: this.pros.location.state.cmbDestination,
                      // txtNetWt: this.pros.location.state.txtNetWt,
                      // txtTransportRate: this.pros.location.state.txtTransportRate,
                      // txtTransportAmount:
                      //   this.pros.location.state.txtTransportAmount,
                      // cmbType: this.pros.location.state.cmbType,
                      // txtDiseal: this.pros.location.state.txtDiseal,
                      // txtDistance: this.pros.location.state.txtDistance,
                    },
                  },
                  () => {
                    if (this.state.formData.cmbType === "Remain") {
                      this.setState({
                        ispaid: false,
                      });
                    }
                    if (
                      res.data.TripList[0]?.vac_wbc_trantype === "Paid" &&
                      !this.state.isEditMode &&
                      !this.state.hasOpenedTransactionType
                    ) {
                      this.setState({ hasOpenedTransactionType: false });
                    } else if (
                      res.data.TripList[0]?.vac_wbc_trantype === "Remain"
                    ) {
                      this.setState({
                        isEditMode: false,
                        isInitialLoad: false,
                      });
                    }
                  }
                );
                document.getElementById("dtpDate").focus();
              }
            })
            .catch((error) => {
              this.props.toastMsg(
                "error",
                "Unkonwn Error occured in onFormLoad. " + error
              );
            });
        } else {
          let reqData = {
            Op: "LoadTripAllCmbDetail",
            bint_acid: localStorage.getItem("acid"),
            bint_acyear: localStorage.getItem("ACY"),
            vac_userid: localStorage.getItem("logInID"),
            // bint_ci: localStorage.getItem("CI"),
            // bint_tripcode: this.state.formData.txtTripCode,
          };

          fetchTripDetail(reqData)
            .then((res) => {
              dataLoadStatus = true;
              this.setState({ isEditMode: false, isInitialLoad: false });
              let Customer = [],
                Truck = [],
                Driver = [],
                WayBridge = [],
                Place = [],
                rowsPaymentMode = [],
                DefaultEntrySettingList = [],
                LedgerList = [],
                PaymentData = [],
                TripRate = [],
                WayBridgeCharge = [],
                cmbType = "",
                rowsCountPaymentMode = rowsPaymentMode.length;
              if (res.data.CustomerList && res.data.CustomerList.length > 0) {
                Customer = res.data.CustomerList;
                if (
                  res.data.LedgerNameList &&
                  res.data.LedgerNameList.length > 0
                ) {
                  rowsPaymentMode = res.data.LedgerNameList;
                  rowsCountPaymentMode = rowsPaymentMode.length;
                }
                if (
                  res.data.DefaultEntrySettingList &&
                  res.data.DefaultEntrySettingList.length > 0
                ) {
                  DefaultEntrySettingList = res.data.DefaultEntrySettingList;
                }
                if (DefaultEntrySettingList.length > 0) {
                  cmbType = DefaultEntrySettingList[0].vac_transacationtype;
                }
                if (res.data.PaymentData && res.data.PaymentData.length > 0) {
                  PaymentData = res.data.PaymentData;
                }
                if (res.data.LedgerList && res.data.LedgerList.length > 0) {
                  LedgerList = res.data.LedgerList;
                }
                if (res.data.TruckList && res.data.TruckList.length > 0) {
                  Truck = res.data.TruckList;
                }
                if (res.data.DriverList && res.data.DriverList.length > 0) {
                  Driver = res.data.DriverList;
                }
                if (
                  res.data.WayBridgeList &&
                  res.data.WayBridgeList.length > 0
                ) {
                  WayBridge = res.data.WayBridgeList;
                }
                if (res.data.PlaceList && res.data.PlaceList.length > 0) {
                  Place = res.data.PlaceList;
                }

                if (
                  res.data.DriverTripRateList &&
                  res.data.DriverTripRateList.length > 0
                ) {
                  TripRate = res.data.DriverTripRateList;
                }
                if (
                  res.data.WayBridgeChargeList &&
                  res.data.WayBridgeChargeList.length > 0
                ) {
                  WayBridgeCharge = res.data.WayBridgeChargeList;
                }
                console.log("res.data.LedgerNameList", res.data.LedgerNameList);

                this.setState({
                  Customer,
                  rowsPaymentMode,
                  rowsCountPaymentMode,
                  PaymentData,
                  Truck,
                  Driver,
                  TripRate,
                  WayBridgeCharge,
                  DefaultEntrySettingList,
                  WayBridge,
                  Place,
                  LedgerList,
                  formData: {
                    ...this.state.formData,
                    cmbType,
                  },
                });
                document.getElementById("dtpDate").focus();
              }
            })
            .catch((error) => {
              console.log("Unknown error occurred in onFormLoad.", error);
            });
        }
      }
    );
  };

  handleOnList = () => {};

  setPaymentData = (rowsPaymentMode) => {
    this.setState(
      {
        rowsPaymentMode,
      },
      () => {
        // console.log("this.state.rows", this.state.rows);
      }
    );
  };

  getDefaultEntrySettingRow = () => {
    let DefaultEntrySettingList = [];
    if (
      this.state.DefaultEntrySettingList &&
      this.state.DefaultEntrySettingList.length > 0
    ) {
      if (
        this.state.DefaultEntrySettingList[0].vac_transacationtype == "Paid"
      ) {
        DefaultEntrySettingList = this.state.DefaultEntrySettingList[0];
      } else {
        if (
          this.state.DefaultEntrySettingList[1].vac_transacationtype == "Paid"
        ) {
          DefaultEntrySettingList = this.state.DefaultEntrySettingList[1];
        }
      }
    }
    return DefaultEntrySettingList;
  };

  openTransactionType = () => {
    let ARD = null;
    let { PaymentData, rowsPaymentMode } = this.state;
    let DefaultEntrySettingList = this.getDefaultEntrySettingRow();

    let txtAmount4PaymentModeTable = Number(
      this.state.formData.txtWayBridgeCharge
    );

    this.setState({ ARD }, () => {
      ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          maxWidthClass={"xl"}
          alertMessage={
            <PaymentModeTable
              DefaultEntrySettingList={DefaultEntrySettingList}
              PaymentData={PaymentData}
              PaymentLedgerNameList={rowsPaymentMode}
              Edit_SrNo={this.state.formData.txtTripCode}
              setPaymentData={this.setPaymentData}
              txtAmount={txtAmount4PaymentModeTable}
            />
          }
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
          handleOnClickNo={() => {
            this.setLedgerDetail();
          }}
        />
      );
      this.setState({ ARD });
      console.log("rowsPaymentMode:", this.state.rowsPaymentMode);
    });
  };

  refreshPaymentList = (rows, rowsCount) => {
    this.setState({
      rows,
      rowsCount,
    });
  };

  getPayRemarkLblVisibleStatus = () => {
    return this.state.formData.cmbType == "Remain" &&
      Number(this.state.formData.txtAmount) > 0 &&
      this.state.formData.chkReceiptGenerated === false
      ? true
      : false;
  };

  getPaymentModeDataStatus = () => {
    let result = false;
    if (
      this.state.formData.cmbType == "Paid" ||
      this.getPayRemarkLblVisibleStatus()
    ) {
      result = true;
    } else {
      this.state.rowsPaymentMode.map((row) => {
        // row.vac_ledgername = ''
        row.dec_amount = "";
        row.vac_chequeno = "";
        row.vac_referenceno = "";
        row.dat_transactiondate = "";
        row.vac_remark = "";
      });
    }
    return result;
    return this.state.formData.cmbType == "Paid" ||
      this.getPayRemarkLblVisibleStatus()
      ? true
      : false;
  };

  clearInfo = () => {
    let txtTripCode = "",
      dtpDate = get_YMD_from_SYS(new Date()),
      cmbTruckNo = "",
      cmbPartyCustomer = "",
      cmbDeparture = "",
      cmbDestination = "",
      txtNetWt = "",
      txtTransportRate = "",
      cmbDriver = "",
      txtTripRate = "",
      cmbWayBridge = "",
      txtWayBridgeCharge = "",
      cmbType = this.state.formData.cmbType,
      txtTransportAmount = "",
      txtTripTotalAmount = "",
      txtDistance = "",
      txtDiseal = "";
    this.setState(
      {
        formData: {
          ...this.state.formData,
          txtTripCode,
          dtpDate,
          cmbTruckNo,
          cmbPartyCustomer,
          cmbDeparture,
          cmbDestination,
          txtNetWt,
          txtTransportRate,
          cmbDriver,
          txtTripRate,
          cmbWayBridge,
          txtWayBridgeCharge,
          cmbType,
          txtTransportAmount,
          txtTripTotalAmount,
          txtDistance,
          txtDiseal,
        },
      },
      () => {
        document.getElementById("cmbTruckNo").focus();
        this.setState((prevState) => ({
          rowsPaymentMode: prevState.rowsPaymentMode.map((row) => {
            return {
              ...row,
              dec_amount: 0,
            };
          }),
        }));
      }
    );
  };

  validateTrip = () => {
    let result = false;
    if (this.state.formData.dtpDate.length <= 0) {
      this.props.toastErrorMsg("Enter Date", "dtpDate");
    } else if (
      validatedate_min_max(
        this.state.formData.dtpDate,
        "dtpDate",
        this.props.toastErrorMsg
      ) == false
    ) {
      return false;
    } else if (this.state.formData.cmbTruckNo.length <= 0) {
      this.props.toastErrorMsg("Enter Truck No.", "cmbTruckNo");
    } else if (
      !isValidItem(
        this.state.Truck,
        "vac_truckno",
        this.state.formData.cmbTruckNo
      )
    ) {
      this.props.toastErrorMsg("Enter Valid Truck No.", "cmbTruckNo");
    } else if (this.state.formData.cmbPartyCustomer.length <= 0) {
      this.props.toastErrorMsg("Enter Customer", "cmbPartyCustomer");
    } else if (
      !isValidItem(
        this.state.Customer,
        "vac_customer",
        this.state.formData.cmbPartyCustomer
      )
    ) {
      this.props.toastErrorMsg("Enter Valid Customer", "cmbPartyCustomer");
    } else if (this.state.formData.cmbDeparture.length <= 0) {
      this.props.toastErrorMsg("Enter Departure", "cmbDeparture");
    } else if (
      !isValidItem(
        this.state.Place,
        "vac_placename",
        this.state.formData.cmbDeparture
      )
    ) {
      this.props.toastErrorMsg("Enter Valid Departure", "cmbDeparture");
    } else if (this.state.formData.cmbDestination.length <= 0) {
      this.props.toastErrorMsg("Enter Destination", "cmbDestination");
    } else if (
      !isValidItem(
        this.state.Place,
        "vac_placename",
        this.state.formData.cmbDestination
      )
    ) {
      this.props.toastErrorMsg("Enter Valid Destination", "cmbDestination");
    } else if (Number(this.state.formData.txtNetWt) <= 0) {
      this.props.toastErrorMsg("Enter Net Wt.", "txtNetWt");
    } else if (Number(this.state.formData.txtTransportRate) <= 0) {
      this.props.toastErrorMsg("Enter Transport Rate", "txtTransportRate");
    } else if (
      this.state.formData.cmbDriver.length <= 0 &&
      isValidItem(
        this.state.Driver,
        "vac_driver",
        this.state.formData.cmbDriver
      ) == false
    ) {
      this.props.toastErrorMsg("Enter Driver Name", "cmbDriver");
    } else if (
      !isValidItem(
        this.state.Driver,
        "vac_driver",
        this.state.formData.cmbDriver
      )
    ) {
      this.props.toastErrorMsg("Enter Valid Driver Name", "cmbDriver");
    }
    //  else if (this.state.formData.cmbWayBridge.length <= 0) {
    //   this.props.toastErrorMsg("Enter Way Bridge Name", "cmbWayBridge");
    // }
    else if (
      this.state.formData.cmbWayBridge.length > 0 &&
      !isValidItem(
        this.state.WayBridge,
        "vac_waybridgename",
        this.state.formData.cmbWayBridge
      )
    ) {
      this.props.toastErrorMsg("Enter Valid Way Bridge Name", "cmbWayBridge");
    } else if (this.state.formData.cmbType.length <= 0) {
      this.props.toastErrorMsg("Enter WBC Transaction Type", "cmbType");
    } else {
      result = true;
    }
    return result;
  };
  validatePaymentModeAmount = () => {
    let result = false,
      dec_amount = 0;
    if (
      this.getPaymentModeDataStatus &&
      this.state.rowsPaymentMode.length > 0
    ) {
      this.state.rowsPaymentMode.map((row) => {
        if (row.dec_amount != undefined) {
          dec_amount += Number(row.dec_amount);
        }
      });
      if (this.state.formData.cmbType === "Paid") {
        if (dec_amount == Number(this.state.formData.txtWayBridgeCharge)) {
          result = true;
        } else {
          this.props.toastErrorMsg(
            "Way Bridge Charge Amount and Payment Mode Ledger Amount must be same",
            "txtWayBridgeCharge"
          );
        }
      } else if (this.state.formData.cmbType === "Remain") {
        result = true;
      }
    } else {
      result = true;
    }
    return result;
  };
  SaveTrip = () => {
    if (this.state.isSaving) {
      return;
    }
    this.trimFormData(() => {
      if (this.validateTrip() && this.validatePaymentModeAmount()) {
        let dataLoadStatus = false;
        this.props.notifyProcessing();
        this.setState({ dataLoadStatus: false, isSaving: true }, () => {
          let reqData = {
            Op: "SaveTrip",
            bint_acid: localStorage.getItem("acid"),
            bint_acyear: localStorage.getItem("ACY"),
            bint_tripcode: this.state.formData.txtTripCode,
            dat_tripdaate: this.state.formData.dtpDate,
            vac_truckno: this.state.formData.cmbTruckNo,
            vac_customer: this.state.formData.cmbPartyCustomer,
            vac_departure: this.state.formData.cmbDeparture,
            vac_destination: this.state.formData.cmbDestination,
            vac_placename: this.state.formData.cmbDestination,
            dec_netwt: this.state.formData.txtNetWt,
            dec_transportrate: this.state.formData.txtTransportRate,
            dec_transportamount: this.state.formData.txtTransportAmount,
            vac_drivername: this.state.formData.cmbDriver,
            dec_triprate: this.state.formData.txtTripRate,
            vac_waybridgename: this.state.formData.cmbWayBridge,
            dec_waybridgecharge: this.state.formData.txtWayBridgeCharge,
            vac_wbc_trantype: this.state.formData.cmbType,
            dec_triptotalamount: this.state.formData.txtTripTotalAmount,
            dec_distance: this.state.formData.txtDistance,
            dec_diseal: this.state.formData.txtDiseal,
            PaymentData: this.getPaymentModeDataStatus()
              ? this.state.rowsPaymentMode
              : [],
            vac_customerledgername: this.state.formData.vac_customerledgername,
            vac_customergroupname: this.state.formData.vac_customergroupname,
            bint_customerladgercode:
              this.state.formData.bint_customerladgercode,
            vac_salesledgername: this.state.formData.vac_salesledgername,
            vac_salesgroupname: this.state.formData.vac_salesgroupname,
            bint_salesladgercode: this.state.formData.bint_salesladgercode,
            vac_purchaseledgername: this.state.formData.vac_purchaseledgername,
            vac_purchasegroupname: this.state.formData.vac_purchasegroupname,
            bint_purchasesladgercode:
              this.state.formData.bint_purchasesladgercode,
            vac_driverledgername: this.state.formData.vac_driverledgername,
            vac_drivergroupname: this.state.formData.vac_drivergroupname,
            bint_driverladgercode: this.state.formData.bint_driverladgercode,
            vac_waybridgeledgername:
              this.state.formData.vac_waybridgeledgername,
            vac_waybridgegroupname: this.state.formData.vac_waybridgegroupname,
            bint_waybridgledgercode:
              this.state.formData.bint_waybridgledgercode,
            bint_ledgercodewaybridge:
              this.state.formData.bint_ledgercodewaybridge,
          };
          fetchTripDetail(reqData)
            .then((res) => {
              this.props.updateProcessing(res.data.msgType, res.data.message);
              if (res.data.msgType === "success") {
                dataLoadStatus = true;

                this.setState({
                  dataLoadStatus,
                  isSaving: false,
                });
                this.clearInfo();
              } else {
                this.setState({ isSaving: false }); // Reset the flag on failure
              }
            })
            .catch((error) => {
              console.log(
                "Unknown error occurred in SaveReferenceMaster.",
                error
              );
            });
        });
      }
    });
  };

  render() {
    return (
      <form>
        {/* <Progress
          color="primary"
          display={this.state.dataLoadStatus !== true}
        /> */}
        {/* <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="title"
        >
          <label htmlFor="Title" style={{ fontSize: "25px", color: "#6f7689" }}>
            <b>Trip Entry</b>
          </label>
        </Grid> */}
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
        >
          <Grid item>
            <Grid
              container
              direction="row"
              spacing={2}
              justifyContent="flex-start"
              alignItems="center"
              marginTop={0}
            >
              <Grid item>
                <CtTxtNum
                  id="txtTripCode"
                  label="Trip Code*"
                  disabled={true}
                  value={this.state.formData.txtTripCode}
                  handleOnChange={this.handleOnChange}
                  width={85}
                  maxLength={10}
                  onKeyDown={this.props.onKeyDown}
                />
              </Grid>
              <Grid item>
                <CtDtp
                  id="dtpDate"
                  label="Date*"
                  width="150"
                  handleOnChange={this.handleOnChange}
                  defaultValue={this.state.formData.dtpDate}
                  value={this.state.formData.dtpDate}
                  onKeyDown={this.props.onKeyDown}
                  accountYear={localStorage.getItem("ACY")}
                  nextCtrlID="cmbTruckNo"
                />
              </Grid>
            </Grid>

            <Grid
              container
              direction="row"
              spacing={2}
              marginTop={0}
              justifyContent="flex-start"
              alignItems="center"
            >
              <Grid item>
                <CtCmbEditable
                  id="cmbTruckNo"
                  label="Truck No.*"
                  items={this.state.Truck}
                  value={this.state.formData.cmbTruckNo}
                  handleOnChange={this.handleOnChange}
                  width={215}
                  maxLength={100}
                  colID="vac_truckno"
                  bolVisibleOnAddClickIcon={
                    this.props.userPrivilege.Customer == "A" ? true : false
                  }
                  onAddClick={this.onAddClickMasterTruck}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="cmbPartyCustomer"
                />
              </Grid>

              <Grid item>
                <CtCmbEditable
                  id="cmbPartyCustomer"
                  label="Party / Customer*"
                  items={this.state.Customer}
                  value={this.state.formData.cmbPartyCustomer}
                  handleOnChange={this.handleOnChange}
                  width={250}
                  maxLength={100}
                  colID="vac_customer"
                  bolVisibleOnAddClickIcon={
                    this.props.userPrivilege.Customer == "A" ? true : false
                  }
                  onAddClick={this.onAddClickCustomerMaster}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="cmbDeparture"
                />
              </Grid>
            </Grid>

            <Grid
              container
              direction="row"
              spacing={2}
              marginTop={0}
              justifyContent="flex-start"
              alignItems="center"
            >
              <Grid item>
                <CtCmbEditable
                  id="cmbDeparture"
                  label="Departure*"
                  items={this.state.Place}
                  value={this.state.formData.cmbDeparture}
                  handleOnChange={this.handleOnChange}
                  width={215}
                  maxLength={100}
                  colID="vac_placename"
                  bolVisibleOnAddClickIcon={
                    this.props.userPrivilege.Customer == "A" ? true : false
                  }
                  onAddClick={this.onClickPlaceMaster}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="cmbDestination"
                />
              </Grid>
              <Grid item>
                <CtCmbEditable
                  id="cmbDestination"
                  label="Destination*"
                  items={this.state.Place}
                  value={this.state.formData.cmbDestination}
                  handleOnChange={this.handleOnChange}
                  colID="vac_placename"
                  bolVisibleOnAddClickIcon={
                    this.props.userPrivilege.Customer == "A" ? true : false
                  }
                  onAddClick={this.onClickPlaceMaster}
                  width={250}
                  maxLength={100}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtNetWt"
                />
              </Grid>
            </Grid>

            <Grid
              container
              direction="row"
              spacing={2}
              marginTop={0}
              justifyContent="flex-start"
              alignItems="center"
            >
              <Grid item>
                <CtTxtAmt
                  id="txtNetWt"
                  label="Net Wt.*"
                  value={this.state.formData.txtNetWt}
                  handleOnChange={this.handleOnChange}
                  width={120}
                  maxLength={10}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtTransportRate"
                />
              </Grid>
              <Grid item>
                <CtTxtAmt
                  id="txtTransportRate"
                  label="Transport Rate*"
                  value={this.state.formData.txtTransportRate}
                  handleOnChange={this.handleOnChange}
                  width={120}
                  maxLength={10}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="cmbDriver"
                />
              </Grid>
              <Grid item>
                <CtTxtAmt
                  id="txtTransportAmount"
                  value={this.state.formData.txtTransportAmount}
                  handleOnChange={this.handleOnChange}
                  label="Transport Amount"
                  width={250}
                  disabled={true}
                  maxLength={10}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="cmbDriver"
                />
              </Grid>
            </Grid>

            <Grid
              container
              direction="row"
              spacing={2}
              marginTop={0}
              justifyContent="flex-start"
              alignItems="center"
            >
              <Grid item>
                <CtCmbEditable
                  id="cmbDriver"
                  label="Driver*"
                  items={this.state.Driver}
                  colID="vac_driver"
                  value={this.state.formData.cmbDriver}
                  handleOnChange={this.handleOnChange}
                  width={215}
                  maxLength={100}
                  bolVisibleOnAddClickIcon={
                    this.props.userPrivilege.Customer == "A" ? true : false
                  }
                  onAddClick={this.onAddClickDriver}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtTripRate"
                />
              </Grid>
              <Grid item>
                <CtTxtAmt
                  id="txtTripRate"
                  value={this.state.formData.txtTripRate}
                  handleOnChange={this.handleOnChange}
                  label="Driver Trip Rate"
                  width={250}
                  maxLength={10}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="cmbWayBridge"
                />
              </Grid>
            </Grid>
            <Grid container>
              <Grid item>
                <Grid
                  container
                  direction="row"
                  spacing={2}
                  marginTop={0}
                  justifyContent="flex-start"
                  alignItems="center"
                >
                  <Grid item>
                    <CtCmbEditable
                      id="cmbWayBridge"
                      label="Way Bridge"
                      items={this.state.WayBridge}
                      colID="vac_waybridgename"
                      value={this.state.formData.cmbWayBridge}
                      handleOnChange={this.handleOnChange}
                      width={215}
                      maxLength={100}
                      bolVisibleOnAddClickIcon={
                        this.props.userPrivilege.Customer == "A" ? true : false
                      }
                      onAddClick={this.onAddClickWayBridgeMaster}
                      onKeyDown={this.props.onKeyDown}
                      nextCtrlID="txtWayBridgeCharge"
                    />
                  </Grid>

                  <Grid item>
                    <CtTxtAmt
                      id="txtWayBridgeCharge"
                      label="Way Bridge Charge"
                      value={this.state.formData.txtWayBridgeCharge}
                      handleOnChange={this.handleOnChange}
                      width={145}
                      maxLength={10}
                      onKeyDown={this.props.onKeyDown}
                      nextCtrlID="cmbType"
                    />
                  </Grid>
                  <Grid item>
                    <CtCmb
                      id="cmbType"
                      label=""
                      items={this.state.Type}
                      value={this.state.formData.cmbType}
                      handleOnChange={this.handleOnChange}
                      width={85}
                      maxLength={100}
                      onKeyDown={this.props.onKeyDown}
                      nextCtrlID="txtWayBridgeCharge"
                      disabled={
                        (this.state.ispaid === true &&
                          this.state.formData.cmbType === "Paid") ||
                        (this.state.formData.cmbType !== "Paid" &&
                          (Number(this.state.formData.txtWayBridgeCharge) ===
                            0 ||
                            this.state.formData.txtWayBridgeCharge === ""))
                      }
                    />
                  </Grid>
                  {this.state.formData.cmbType === "Paid" &&
                    this.state.ispaid !== true && (
                      <img
                        src={PaymentModeIcon}
                        alt="Payment Mode"
                        style={{
                          marginTop: "40px",
                          paddingBottom: "4px",
                          paddingLeft: "8px",
                          paddingRight: "8px",
                          cursor: "pointer",
                          width: "34px", // Adjust as needed
                          height: "34px",
                        }}
                        onClick={this.openTransactionType}
                      />
                    )}
                </Grid>

                <Grid
                  container
                  direction="row"
                  spacing={2}
                  marginTop={0}
                  justifyContent="flex-start"
                  alignItems="center"
                >
                  <Grid item>
                    <CtTxtAmt
                      id="txtTripTotalAmount"
                      value={this.state.formData.txtTripTotalAmount}
                      handleOnChange={this.handleOnChange}
                      label="Trip Total Amount"
                      width={250}
                      disabled={true}
                      maxLength={10}
                      onKeyDown={this.props.onKeyDown}
                    />
                  </Grid>

                  <Grid item>
                    <CtTxtAmt
                      id="txtDistance"
                      value={this.state.formData.txtDistance}
                      handleOnChange={this.handleOnChange}
                      label="Distance (KM)"
                      width={120}
                      // disabled={true}
                      maxLength={10}
                      onKeyDown={this.props.onKeyDown}
                      nextCtrlID="txtDiseal"
                    />
                  </Grid>
                  <Grid item>
                    <CtTxtAmt
                      id="txtDiseal"
                      value={this.state.formData.txtDiseal}
                      handleOnChange={this.handleOnChange}
                      label="Diesel (Ltr)"
                      width={120}
                      // disabled={true}
                      maxLength={10}
                      onKeyDown={this.props.onKeyDown}
                      defaultAction={this.SaveTrip}
                    />
                  </Grid>
                </Grid>

                <Grid
                  container
                  direction="row"
                  spacing={2}
                  margin={1}
                  justifyContent="flex-start"
                  alignItems="center"
                >
                  <Grid item>
                    <CtBtn
                      label="Save"
                      onClick={this.SaveTrip}
                      disabled={this.state.isSaving}
                    />
                  </Grid>
                  <Grid item>
                    <CtBtn
                      label="Trip List"
                      iconName={"List"}
                      onClick={() => {
                        this.props.navigateTo("TripList");
                      }}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item>
                    <CtBtn
                      label="New"
                      onClick={this.clearInfo}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item>
                    <CtBtn
                      label="Delete"
                      disabled={
                        Number(this.state.formData.txtTripCode) > 0
                          ? false
                          : true
                      }
                      onClick={this.DeleteData}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item>
                <Box>
                  {this.state.rowsPaymentMode.map((row, index) => {
                    if (
                      this.state.formData.cmbType !== "Paid" ||
                      !row.dec_amount
                    ) {
                      return null;
                    }

                    const backgroundprocess = row.vac_backgroundprocess;
                    if (
                      !["Cash", "Cheque", "Bank"].includes(backgroundprocess)
                    ) {
                      return null;
                    }

                    return (
                      <Box key={`payment-${index}`}>
                        <h4 style={{ margin: 5 }}>
                          Payment Mode: {row.vac_ledgername}
                        </h4>
                        <h4 style={{ margin: 5 }}>Amount: {row.dec_amount}</h4>
                        <h4 style={{ margin: 5 }}>
                          Cheque No: {row.vac_chequeno}
                        </h4>
                        <h4 style={{ margin: 5 }}>
                          Reference No: {row.vac_referenceno}
                        </h4>
                        <h4 style={{ margin: 5 }}>
                          Transaction Date:{" "}
                          {row.dat_transactiondate &&
                          row.dat_transactiondate !== "0000-00-00"
                            ? moment(row.dat_transactiondate).format(
                                "DD-MM-YYYY"
                              )
                            : ""}
                        </h4>
                        <h4 style={{ margin: 5 }}>Remark: {row.vac_remark}</h4>
                        <hr />
                      </Box>
                    );
                  })}
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* <br />
        <Box>
          {this.state.rowsPaymentMode.map((row, index) => {
            if (this.state.formData.cmbType !== "Paid" || !row.dec_amount) {
              return null;
            }

            const backgroundprocess = row.vac_backgroundprocess;
            if (!["Cash", "Cheque", "Bank"].includes(backgroundprocess)) {
              return null;
            }

            return (
              <Box key={`payment-${index}`}>
                <h4 style={{ margin: 5 }}>
                  Payment Mode: {row.vac_ledgername}
                </h4>
                <h4 style={{ margin: 5 }}>Amount: {row.dec_amount}</h4>
                <h4 style={{ margin: 5 }}>Cheque No: {row.vac_chequeno}</h4>
                <h4 style={{ margin: 5 }}>
                  Reference No: {row.vac_referenceno}
                </h4>
                <h4 style={{ margin: 5 }}>
                  Transaction Date:{" "}
                  {row.dat_transactiondate &&
                  row.dat_transactiondate !== "0000-00-00"
                    ? moment(row.dat_transactiondate).format("DD-MM-YYYY")
                    : ""}
                </h4>
                <h4 style={{ margin: 5 }}>Remark: {row.vac_remark}</h4>
                <hr />
              </Box>
            );
          })}
        </Box> */}

        {/* <Grid item marginTop={3} className="maintable">
                <MaterialTable
                rowsdata={this.state.rows}
                columnsdata={this.state.columns}
                rowsPerPage={this.state.rowsPerPage}
                tblmaxHeight={500}
                csvFileName={csvFileName("Trip Item Entry")}
                newBtnName={"New Trip Item"}
                newBtnClick={this.handleOnNewEntryClick}
                onEditAction={this.handleARDonActionClick_Edit}
                onDeleteAction={this.handleARDonActionClick_Delete}
                showColumnFilters={false}
                actionColSize={90}
                density={"compact"}
              />
            </Grid> */}
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </form>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps
)(HOCVerifyIsUser(HoCtToastContainer(withRouter(TripEntry))));
